export const STORAGE_KEY = 'xxwl'
export const CRUMB = 'crumb'
export const WRITE_CRUMB = 'write_crumb'
export const READ_CRUMB = 'read_crumb'
export const CLEAN_CRUMB = 'clean_crumb'
export const WORKS = 'works'
export const WRITE_WORKS = 'write_works'
export const READ_WORKS = 'read_works'
export const MODIDY_WORKS = 'modify_works'
export const CLEAN_WORKS = 'clean_works'
export const USER = 'user'
export const READ_USER = 'read_user'
export const WRITE_USER = 'write_user'
export const CLEAN_USER = 'clean_user'
export const SUBJECT = 'subject'
export const READ_SUBJECT = 'read_subject'
export const WRITE_SUBJECT = 'write_subject'
export const CLEAN_SUBJECT = 'clean_subject'
export const TOAST = 'toast'
export const WRITE_TOAST = 'write_toast'
export const CLEAN_TOAST = 'clean_toast'
export const CATALOG = 'catalog'
export const WRITE_CATALOG = 'write_catalog'
export const CLEAN_CATALOG = 'clean_catalog'
export const STATE = 'navstate'
export const WRITE_STATE = 'write_navstate'
export const CLEAN_STATE = 'clean_navstate'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js